<template>
    <div class="selectboxes-component">
        <div class="block">
            <div v-for="option in component.values" :key="option.value">
                <b-checkbox
                    @input="checkboxAction(option.value, $event)"
                    :native-value="option.value.trim()"
                    v-model="currentValues"
                    >
                    {{ option.label }}
                </b-checkbox>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  name: 'SelectBoxes',
  components: {
  },
  props: {
      component: Object,
      value: [],
      required: Boolean,
  },
  data: function () {
      return {
        currentValues: [],
      }
  },
  computed: {
  },
  methods: {
    checkboxAction(cbValue, event){
      this.$emit('input', this.currentValues);
    }
  },
  mounted(){
    if(this.value)
      this.currentValues.push(...this.value);
  },

}

</script>

<style>
</style>

